import { render } from "./MyWeeklyPromotion.vue?vue&type=template&id=b7fce330"
import script from "./MyWeeklyPromotion.vue?vue&type=script&lang=js"
export * from "./MyWeeklyPromotion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__